import React from 'react';

import LoginModel from '../../models/Login';

import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import InputAdornment from '@material-ui/core/InputAdornment';

import AccountCircle from '@material-ui/icons/AccountCircle';
import LockIcon from '@material-ui/icons/Lock';

import appStyles from '../../App/app.module.css';
import loginStyles from './login.module.css';
import commonStyles from '../common/common.module.css';
import menuIcon from '../../assets/FD_Logo.png';

const styles = (theme: any) =>

  createStyles({
    textField: {
      marginLeft: theme.spacing.unit,
      marginRight: theme.spacing.unit,
      '& fieldset': {
        boxShadow: '2px 2px 5px rgba(0, 0, 0, 0.349019607843137)',
        borderRadius: '10px'
      }
    },
    button: {
      margin: theme.spacing.unit,
      height: '40px',
      borderRadius: '10px',
    },
    loginInput: {
      backgroundColor: 'white',
      padding: '14px 12px',
      borderRadius: '10px',
      fontSize: '14px'
    },
    loginLabel: {
      color: '#FFF !important',
      fontSize: '16px',
      backgroundColor: 'var(--primaryblue)',
      borderRadius: '20px',
      padding: '5px 12px'
    },
    materialIcon: {
      fontSize: '30px'
    }
  });

interface LoginProps extends WithStyles<typeof styles> {
  fields: LoginModel,
  errors: LoginModel,
  submit: (event: any) => void,
  change: any;
  loadResetPasswordPage: () => void;
};

const Login = (props: LoginProps) => {

  const { classes } = props;

  return (
    
    <div className={`${loginStyles.loginRow} ${loginStyles.loginContainer}`} >

      <div>
        <div className={`${loginStyles.loginRow} ${commonStyles.pt0}`}>
          <img alt="logo" src={menuIcon} className={loginStyles.logoImg} />
          <h1 className={loginStyles.loginHeader}>TryPod</h1>
        </div>

        <div className={loginStyles.loginRow}>
          <div className={loginStyles.loginCol}>

            <form className={appStyles.col} onSubmit={props.submit}>
              <FormControl>
                <TextField
                  id="outlined-email"
                  name='email'
                  label=""
                  className={classes.textField}
                  value={props.fields.email}
                  onChange={event => props.change(event, "email")}
                  error={props.errors.email !== ''}
                  helperText={props.errors.email !== '' ? props.errors.email : ' '}
                  margin="normal"
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccountCircle color="primary" className={ classes.materialIcon }/>
                      </InputAdornment>
                    ),
                    classes: { input: classes.loginInput }
                  }}
                  placeholder="Email/Username*"
                />
                <TextField
                  id="outlined-password"
                  label=""
                  type="password"
                  className={classes.textField}
                  value={props.fields.password}
                  onChange={event => props.change(event, "password")}
                  error={props.errors.password !== ''}
                  helperText={props.errors.password !== '' ? props.errors.password : ' '}
                  margin="normal"
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockIcon color="primary" className={ classes.materialIcon }/>
                      </InputAdornment>
                    ),
                    classes: { input: classes.loginInput }
                  }}
                  placeholder="Password*"
                />
                <Button type="submit" color="primary" variant="contained" className={classes.button} > Continue </Button>
              </FormControl>
            </form>

          </div>
        </div>

        <div className={loginStyles.loginRow}>
          <div className={loginStyles.loginFooter} onClick={props.loadResetPasswordPage}>I forgot my password</div>
        </div> 
      </div>
      
    </div>
  );
};

export default withStyles(styles)(Login);